// extracted by mini-css-extract-plugin
export default {"layout":"OverviewPage_layout__Ku9Oq","bottom":"OverviewPage_bottom__4Pvjp"};